import Button from '@jetbrains/ring-ui/components/button/button'

import AgentAuthDialog from '../AgentAuthDialog/AgentAuthDialog'
import {useAuthAgentDialog} from '../AgentAuthDialog/AgentAuthDialog.hooks'

import type {AgentAuthProps} from './AgentAuth.types'

import styles from './AgentAuth.css'

function AgentAuth({onDialogOpen}: AgentAuthProps) {
  const authDialog = useAuthAgentDialog({
    onOpen: onDialogOpen,
  })
  return (
    <div className={styles.agentAuth}>
      <Button text onClick={authDialog.show} className={styles.open}>
        {'Use authentication token...'}
      </Button>
      {authDialog.visible && <AgentAuthDialog onClose={authDialog.onClose} />}
    </div>
  )
}

export default AgentAuth
